var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-map.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00001 1.33301C5.05935 1.33301 2.66668 3.72567 2.66668 6.66301C2.64735 10.9597 7.79735 14.5223 8.00001 14.6663C8.00001 14.6663 13.3527 10.9597 13.3333 6.66634C13.3333 3.72567 10.9407 1.33301 8.00001 1.33301ZM8.00001 9.33301C6.52668 9.33301 5.33335 8.13967 5.33335 6.66634C5.33335 5.19301 6.52668 3.99967 8.00001 3.99967C9.47335 3.99967 10.6667 5.19301 10.6667 6.66634C10.6667 8.13967 9.47335 9.33301 8.00001 9.33301Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinW);
export default __webpack_public_path__ + "static/media/location-pin-w.5d7b3b0e92d903a0b3adb6c2acb6007c.svg";
export { ForwardRef as ReactComponent };